<div *ngIf="loaded" class="unsubscribe-success">
  <se-fe-card>
    <se-fe-card-header *ngIf="orgName"
      seFeDataTitle="{{ orgName }}"
      [seFeDataBorder]="true">
      <div seFeCardHeaderVisual>
        <se-fe-avatar
          seFeDataType="org"
          [seFeDataIdentity]="orgName"
          [seFeDataImgUrl]="orgLogoUrl"
          seFeDataSize="300">
        </se-fe-avatar>
      </div>
    </se-fe-card-header>

    <se-fe-card-content>
      <header class="se-logo-header" *ngIf="!orgName" >
          <img class="se-logo-header-img" alt="SportsEngine" [src]="seIcon">
      </header>

      <div class="unsubscribe-success-icon">
        <se-fe-icon
          seFeDataName="spot_invite_cancel"
          seFeDataSize="950"
          [seFeDataMargin]="true">
        </se-fe-icon>
      </div>
      <div class="unsubscribe-success-confirm">
        <p>{{ 'FEATURE_UNSUBSCRIBE_SUCCESS.CONFIRMATION' | translate }}</p>
      </div>
      <div class="unsubscribe-success-email-info">
        <span>{{ 'FEATURE_UNSUBSCRIBE_SUCCESS.EMAIL' | translate }}</span>
        <span class="email-address">{{ email }}</span>
        <span>{{ 'FEATURE_UNSUBSCRIBE_SUCCESS.EMAIL_REMOVED' | translate }}</span>
      </div>
      <div class="unsubscribe-success-subscribe">
        <p>{{ 'FEATURE_UNSUBSCRIBE_SUCCESS.RESUBSCRIBE' | translate }}</p>
        <se-fe-button (click)="onClick()" seFeDataEmphasis="medium">{{ 'FEATURE_UNSUBSCRIBE_SUCCESS.BUTTON' | translate }} </se-fe-button>
      </div>
    </se-fe-card-content>
  </se-fe-card>

  <footer class="se-footer">
    <a seFeLink target="_blank" href="https://www.sportsengine.com/terms-of-use" id="footer-link-terms-of-use">
      Terms of Use
    </a> |
    <a seFeLink target="_blank" href="https://www.versantprivacy.com/privacy?brandA=SportsEngine&intake=SportsEngine" id="footer-link-terms-of-use">
      Privacy Policy
    </a>
    <br>
    © {{ footerYear }}
    <a seFeLink target="_blank" href="http://www.sportsengine.com" id="footer-link-sportsengine">
      SportsEngine, LLC.</a>
    All Rights Reserved.
  </footer>
</div>
